import { EActions, EDatalayerState } from '@/core/types';

/**
 * DataLayerStateHandler Responsible for handling the state of the data layer
 */
export class DataLayerStateHandler {
  /**
   * State of the Datalayer
   * Initialized to init state
   */
  private static state: EDatalayerState = EDatalayerState.created;

  /**
   * Get the current state of the datalayer
   */
  public static get currentState(): EDatalayerState {
    return this.state;
  }

  /**
   * Set the state of the datalayer
   * @param state
   */
  public static setState(state: EDatalayerState): void {
    this.state = state;
  }

  /**
   * Check if the datalayer is ready to process a event given the current action
   */
  public static isActionPermissible(action: EActions): boolean {
    // Logger.info('isActionPermissible', action, this.state);
    // Two values -> action and current State dictate if the action is permissible or not

    // *** ACTION === INIT
    if (action === EActions.Init) {
      // Datalayer just created and there's an init action. This works
      switch (this.state) {
        case EDatalayerState.created: {
          return true;
        }
        case EDatalayerState.pending: {
          return false;
        }
        case EDatalayerState.ready: {
          return false;
        }
        case EDatalayerState.error: {
          return true; // TODO: imon check this
        }
        case EDatalayerState.notracking: {
          return true;
        }
        case EDatalayerState.uninitialized: {
          return true;
        }
        // No default
      }
    } else if (action === EActions.Event || action === EActions.Consent) {
      // Datalayer is in init state and there's an event action. Can't do this
      switch (this.state) {
        case EDatalayerState.created: {
          return false;
        }
        case EDatalayerState.pending: {
          return false;
        }
        case EDatalayerState.ready: {
          return true;
        }
        case EDatalayerState.error: {
          return false;
        }
        case EDatalayerState.notracking: {
          return false;
        }
        case EDatalayerState.uninitialized: {
          return false;
        }
        // No default
      }
    }

    // Default False
    return false;
  }
}
